import { NavLink } from "react-router-dom";
import VectorlineIcon from "assets/icons/Vectorline.svg?react";
import RightArrowIcon from "assets/icons/chevron-right.svg?react";
import CactusSaddleIcon from "assets/icons/cactus_saddleIcon.svg?react";
import SaddleOutlineIcon from "assets/icons/saddleIcon.svg?react";
import SeatSizeIcon from "assets/icons/seat-size.svg?react";
import SingleSelectField from "components/ui/single-select";
import { ImageGallery } from "./ImageGallery";
import { FavoriteButton } from "../components/FavouriteBtn";
import { ScoreSection } from "./ScoreSection";
import { ActionButtons } from "../components/ActionButtons";
import { formatString, manufacturerListPath, isBillyCookBrandName } from "utils/index";
import { getBillyCookColorSelectProps } from "components/ui/BillyCookColorSelect";
import { formatDescription, formatPrice, formatProductTitle, saddleSelectStyles } from "../utils";

export const DesktopView = ({
  navigate, filteredSaddle, favouriteList, handleFavourite, handleImageClick,
  user, control, seatSizes, colors, saddle, locationState, watch
}) => {
  const currentIndex = watch("currentIndex");
  const selectedHorseStatus = watch("selectedHorseStatus");
  const favouriteLoading = watch("favouriteLoading");
  const selectedHorse = watch("selectedHorse");
  const filteredScore = Math.round(filteredSaddle?.score);
  const filteredPrice = filteredSaddle?.price;
  const billyCookColorSelectProps = isBillyCookBrandName(filteredSaddle?.brandName)
    ? getBillyCookColorSelectProps("color", saddleSelectStyles)
    : null;

  return (
    <div className="w-full hidden lg:block h-auto py-[61px]">
      <div className="back_to_homepage" onClick={() => navigate(-1)}>
        <div className="flex !w-[130px] items-center cursor-pointer hover:font-bold hover:text-[#5C80B6]">
          <RightArrowIcon />
          <p>Back to Saddles</p>
        </div>
      </div>

      <div className="w-[90%] 2xl:w-[1338px] flex justify-between mx-auto h-auto">
        <div className="w-full md:w-[50%] flex h-full">
          <ImageGallery 
            saddle={filteredSaddle}
            currentIndex={currentIndex}
            handleImageClick={handleImageClick}
          />
        </div>

        <div className="clay-card-saddleDetails">
          <div className="w-full h-auto flex flex-col">
            <div className="saddle-details flex">
              <div className="flex justify-between items-center">
                <NavLink
                  to={manufacturerListPath(filteredSaddle?.brandName)}
                  className="text-[#5B7FB4] text-[28px] font-semibold leading-[110%] font-[Montserrat] cursor-pointer hover:underline"
                >
                  {formatString(filteredSaddle?.brandName)}
                </NavLink>

                <div className="flex flex-row gap-[41.24px]">
                  {isBillyCookBrandName(filteredSaddle?.brandName) ? (
                    <SaddleOutlineIcon className="w-[25px] h-[25px] mr-[2px]" />
                  ) : (
                    <CactusSaddleIcon className="w-[25px] h-[25px] mr-[2px]" />
                  )}
                  {filteredSaddle?.size && (
                    <div className="seat_size_container">
                      <p className="item_size !text-[10px]">SEAT SIZE:</p>
                      <SeatSizeIcon />
                      <p className="item_size">{`${filteredSaddle?.size}"`}</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="flex items-center justify-between">
                <h1 className="text-[36px]">
                  {formatProductTitle(filteredSaddle?.productTitle)}
                </h1>
              </div>

              <div className="flex items-center justify-between">
                <p className="text-[#343434] text-[36px] font-bold">
                  ${formatPrice(filteredPrice)}
                </p>
                <FavoriteButton
                  user={user}
                  saddle={filteredSaddle}
                  favouriteList={favouriteList}
                  favouriteLoading={favouriteLoading}
                  handleFavourite={handleFavourite}
                />
              </div>
            </div>

            <div className="items-center justify-center mt-2">
              <ScoreSection
                selectedHorseStatus={selectedHorseStatus}
                filteredScore={filteredScore}
                navigate={navigate}
              />
            </div>

            <div className="saddle_codesection">
              <div className="flex flex-row flex-wrap items-center gap-x-4 gap-y-4 font-[Montserrat] text-[14px] xl:text-[16px]">
                {saddle?.type === "PRODUCT" && colors?.length > 0 && (
                    <SingleSelectField
                      name="color"
                      label="Color"
                      placeholder="Select Color"
                      height="40px"
                      control={control}
                      options={colors}
                      className="saddle_details_dropdown_formInput"
                    stylesOverride={
                      billyCookColorSelectProps?.stylesOverride ?? saddleSelectStyles
                    }
                    components={billyCookColorSelectProps?.components}
                    />
                )}
                {saddle?.type === "PRODUCT" && (
                    <SingleSelectField
                      name="size"
                      label="Seat Size"
                      placeholder="Select Size"
                      height="40px"
                      control={control}
                      options={seatSizes}
                      className="saddle_details_dropdown_formInput"
                    stylesOverride={saddleSelectStyles}
                    />
                )}
              </div>

              <div className="saddle_report">
                <ActionButtons
                  user={user}
                  filteredSaddle={filteredSaddle}
                  selectedHorse={selectedHorse}
                  locationState={locationState}
                  saddle={saddle}
                  selectedHorseStatus={selectedHorseStatus}
                  handleCheckAuth={() => {}}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="vectorline">
        <VectorlineIcon />
      </div>
      
      <div className="w-[90%] 2xl:w-[1338px] mx-auto mt-[52px]">
        <p className="saddle_information">Saddle Information</p>
        <div className="p-6">
          <div
            className="text-gray-800 leading-relaxed space-y-4 saddle_paragraph"
            dangerouslySetInnerHTML={{ __html: formatDescription(filteredSaddle?.description) }}
          />
        </div>
      </div>
    </div>
  );
};
